import {getCampaignDetails} from "../getCampaignDetails";

export const assignDetails = async (props) => {
    const {
        isOpen, idCampaign, setDrawerOpen, setCampaignName,  setSelectedLanguage,
         setFinalURL, setIsCampaignPaused, setLandscape, setLogo,
    } = props;

    if (isOpen && idCampaign) {
        setDrawerOpen(true);
        const response = await getCampaignDetails(idCampaign);

        if (response.success) {
            const campaign = response.data;

            setCampaignName(campaign.campaign_settings?.campaign_name || "");

            setSelectedLanguage(campaign.campaign_settings?.campaign_lang || "");
            setFinalURL(campaign.campaign_ads_creative?.final_url?.url || "");
            setIsCampaignPaused(campaign.campaign_status !== "ENABLED");

            setLandscape(campaign.campaign_ads_creative?.marketing_image?.map(item => item.assetContent) || []);
            setLogo(campaign.campaign_ads_creative?.logo_image?.map(item => item.assetContent) || []);
        }
        setDrawerOpen(false);
    }
};